import { render, staticRenderFns } from "./ModalImpressao.vue?vue&type=template&id=860a5f90&scoped=true&"
import script from "./ModalImpressao.vue?vue&type=script&lang=js&"
export * from "./ModalImpressao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressao.vue?vue&type=style&index=0&id=860a5f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a5f90",
  null
  
)

export default component.exports